<template>
  <v-tooltip top color="transparent">
    <template v-slot:activator="{ on, attrs }">
      <span class="ai-visibility-info-icon material-icons" v-bind="attrs" v-on="on">
        info
      </span>
    </template>
    <div class="white-bg-tooltip small-tooltip">
      <div v-if="info.title" class="ai-visibility-info-title">{{ info.title }}</div>
      <div v-if="info.tooltip" class="ai-visibility-info-tooltip">{{ info.tooltip }}</div>
    </div>
  </v-tooltip>
</template>

<script>

export default {
  name: 'InfoIcon',
  props: {
    info: {
      type: Object,
      default: function () {
        return {title: '', tooltip: ''}
      },
    }
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  line-height: 1;
}

.ai-visibility-info-title {
  font-size: 14px;
  font-weight: 500;
}

</style>
